import { render, staticRenderFns } from "./updatePhoneNumber.vue?vue&type=template&id=40f73acc&scoped=true&"
import script from "./updatePhoneNumber.vue?vue&type=script&lang=js&"
export * from "./updatePhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./updatePhoneNumber.vue?vue&type=style&index=0&id=40f73acc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f73acc",
  null
  
)

export default component.exports